import { render } from "./ClientTemplateEvent.vue?vue&type=template&id=18011b64&scoped=true"
import script from "./ClientTemplateEvent.vue?vue&type=script&lang=js"
export * from "./ClientTemplateEvent.vue?vue&type=script&lang=js"

import "./ClientTemplateEvent.vue?vue&type=style&index=0&id=18011b64&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18011b64"]])

export default __exports__